import { RevisionHistoryDialogCtrl } from '~src/revisionHistory/controllers/RevisionHistoryDialogCtrl';
import { IActionContext } from '~src/ts/helpers/ActionContext';
import { Set } from '~src/ts/models/Set';
import { IDatasourceRevision } from '~src/revisionHistoryDatasource/serverApi/types/IDatasourceRevision';
import { IActionButton } from '~src/commonInfra/contentActions/ActionPanelInterfaces';
import { DeleteRevisionAction } from '~src/revisionHistory/services/DeleteRevisionAction';
import { RevisionActions } from '~src/revisionHistory/services/RevisionActions';
import {
  RevisionHistoryActionButton,
  RevisionHistoryActionContext,
} from '~src/revisionHistory/interfaces/RevisionHistoryActionContext';

export namespace RevisionActionDatasource {
  export function  getDatasourceRevisionActionButtons(): RevisionHistoryActionButton<IDatasourceRevision>[] {
    return [
      deleteDataSourceRevisionAction(),
      RevisionActions.downloadContentRevisionAction()
    ];
  }

  export function  getDatasourceRevisionActionButtonsAngular(): IActionButton<IDatasourceRevision, {}>[] {
    return [
      deleteDataSourceRevisionActionAngular(),
      RevisionActions.downloadContentRevisionActionAngular()
    ];
  }

  // action button factories
  function deleteDataSourceRevisionAction(): RevisionHistoryActionButton<IDatasourceRevision> {
    return {
      name: 'delete',
      translate: 'delete_action',
      execute: (context: RevisionHistoryActionContext<IDatasourceRevision>) => {
        DeleteRevisionAction.showDeleteDataSourceRevisionDialog(context.selectedItem, context);
      }
    };
  }
  function deleteDataSourceRevisionActionAngular(): IActionButton<IDatasourceRevision, {}> {
    return {
      name: 'delete',
      translate: 'delete_action',
      isAvailable: (items: Set<IDatasourceRevision>) => items.size() === 1,
      execute: (items: Set<IDatasourceRevision>, context: IActionContext) => {
        const scope = <RevisionHistoryDialogCtrl.Scope>context.scope;
        DeleteRevisionAction.showDeleteDataSourceRevisionDialog(items.first(), context).then(() => scope.refreshContent());
      }
    };
  }
}
